module.exports = __webpack_public_path__ + "img/yacht-1.fea5ced0.jpg";